import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import RequestsListCard from 'src/components/RequestsListCard';
import { RootState } from 'src/store';
import {
  getDashboardRequests,
  clearDashboardRequestsData,
  setDashboardRequestCompleted,
} from 'src/store/dashboardRequests/reducer';
import { useAppTour } from 'src/context/appTourContext';
import useWebSocket from 'src/utils/useWebSocket';
import { getCurrentProject } from 'src/utils/localStorage';

export default function Dashboard() {
  const dashboardRequests = useSelector(
    (globalState: RootState) => globalState.dashboardRequests
  );

  const projectRetainerUuid = getCurrentProject();

  const dispatch = useDispatch();
  const { setStepTarget } = useAppTour();

  const fetchRequests = useCallback(
    (loadMore = false) => {
      if (projectRetainerUuid) {
        dispatch(getDashboardRequests({ loadMore }));
      }
    },
    [dispatch, projectRetainerUuid]
  );

  useEffect(() => {
    fetchRequests();
  }, [fetchRequests]);

  useWebSocket({
    channelName: 'model.changes',
    listen: [
      {
        event: '.app.models.projects.request',
        callback: async () => {
          fetchRequests();
        },
      },
      {
        // A new comment does not emit a request event, so without this the card keeps showing
        // the previous latest_comment until the screen is remounted.
        event: '.app.models.foundation.comment',
        callback: (event: any) => {
          const requestUuid = event?.payload?.request_id;

          if (!requestUuid) return;

          const isListed = dashboardRequests.data?.some(
            (request) => request.uuid === requestUuid
          );

          if (isListed) {
            fetchRequests();
          }
        },
      },
    ],
  });

  return (
    <div ref={(node) => setStepTarget(6, node)}>
      <RequestsListCard
        loading={!projectRetainerUuid || dashboardRequests.loading}
        data={dashboardRequests.data}
        showCompletedValue={dashboardRequests.showCompleted}
        hasLoadMore={dashboardRequests.pagination.hasMore}
        onLoadMore={() => fetchRequests(true)}
        onShowAll={(checked) => {
          dispatch(clearDashboardRequestsData());
          dispatch(setDashboardRequestCompleted(checked));
          fetchRequests();
        }}
      />
    </div>
  );
}
